export default {"src":"/_next/static/media/optimizeContentLarge.a541f9fb.svg","height":42,"width":46};